export const CALL_STATES = Object.freeze({
  idle: "idle",
  incoming: "incoming",
  calling: "calling",
  connecting: "connecting",
  connected: "connected",
  queued: "queued",
  call_waiting: "call_waiting",
});

export const CALL_MODES = Object.freeze({
  receiver: "receiver",
  participant: "participant",
  staff: "staff",
  guest: "guest",
});
